import type { AssistantContext } from '@momomail/shared';
import { shell } from './bridge';
import { screenContext } from './screen';
import { uiSnapshot } from './uiSnapshot';

/**
 * What the user has open, for 馍馍 (AssistantContext): the app (where they are, the message they read) and the compose window (the
 * email they write) keep it up to date; it goes along with each chat message — from the chat here, and to the desktop shell for the
 * chat over the desktop cat.
 */
let current: AssistantContext = {};
let timer: ReturnType<typeof setTimeout> | null = null;

export function setAssistantContext(patch: Partial<AssistantContext>) {
  current = { ...current, ...patch };
  // The desktop's chat (over the cat) asks from the main process: tell it, a moment after the typing stops
  if (shell?.assistantContext) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => shell?.assistantContext?.(current), 400);
  }
}

/** The context as of now, with a fresh snapshot of the screen (as text, and as the tree 馍馍 can work: screen.ts). */
export function assistantContext(): AssistantContext {
  return { ...current, screen: uiSnapshot(), ...screenContext() };
}

// The desktop shell takes it from here when the chat over the desktop cat sends a message
(window as unknown as { __momomailAssistantContext?: () => AssistantContext }).__momomailAssistantContext = assistantContext;

/** Window event: 馍馍 wrote into the email being written (detail: { to?, cc?, subject?, body? }). */
export const COMPOSE_FILL = 'momomail:compose-fill';
